// qty.js
export function qxQtyGuard() {
    document.querySelectorAll('input[name="qty"]').forEach(function (i) {
        i.addEventListener('change', function () {
            var v = parseInt(i.value, 10) || 1;
            if (v < 1) i.value = 1;
            if (v > 20) i.value = 20;
        });
    });
}
